import Asset from "./Asset";
import { AssetDataType } from "./AssetType";
import { AspectRatios } from './AspectRatios';
import { FormFactor, OperatingSystem } from "../utilities/UserAgent";
import { toAssetCategory } from "./AssetCategory";
import { Modify } from "../utilities/modifyType";
import { LibraryItem } from "./LibraryItem";
import { LibraryItemType } from "./LibraryItemType";

export interface BuilderAsset extends Asset {
    // HTML content from the builder
    text: string;
    slideCount: number;
    assetType: AssetDataType.EditableText;
    shareId?: string;
    isShared: boolean;
    isTemplate: boolean;
    templateDescription: string;
    slideExporterAspectRatio: AspectRatios;
    customSlideBackgroundImagePath?: string;
    customSlideBackgroundImageUrl?: string;
    offlineMode: boolean;
    lastModifiedOnOperatingSystem?: OperatingSystem;
    lastModifiedFormFactor?: FormFactor;
}

export type SerializedBuilderAsset = Modify<BuilderAsset, {
    category: string;
    dateCreated: string;
	dateModified: string;
	dateAccessed: string;
    datePreached?: string;
    assetType: undefined;
}>;

export const deserializeBuilderAsset = (builderResponse: SerializedBuilderAsset): BuilderAsset => {
	return {
		...builderResponse,
		category: toAssetCategory(builderResponse.category),
		dateAccessed: new Date(builderResponse.dateAccessed),
		dateCreated: new Date(builderResponse.dateCreated),
		dateModified: new Date(builderResponse.dateModified),
		datePreached: builderResponse.datePreached ? new Date(builderResponse.datePreached) : undefined,
		assetType: AssetDataType.EditableText,
	};
};

export const convertBuilderAssetToLibraryItem = (asset:BuilderAsset): LibraryItem => {
    return {
        ...asset,
        type: LibraryItemType.BuilderAsset
    }
};